import type { ReactNode } from 'react';

export interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Visible text beside the box. */
  label?: ReactNode;
  /** Accessible name when there is no visible label. */
  ariaLabel?: string;
  disabled?: boolean;
  size?: number;
  /** A taller hit area, in px, for a touch screen. The box itself keeps its size. */
  minHeight?: number;
}

/** A native checkbox in the theme colours, with an optional visible label. */
export function Checkbox({
  checked,
  onChange,
  label,
  ariaLabel,
  disabled,
  size = 16,
  minHeight,
}: CheckboxProps) {
  return (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        minHeight,
        cursor: disabled ? 'default' : 'pointer',
        fontSize: 12.5,
        color: 'var(--nb-ink)',
      }}
    >
      <input
        type="checkbox"
        className="nb-checkbox"
        checked={checked}
        disabled={disabled}
        aria-label={ariaLabel}
        onChange={(e) => onChange(e.target.checked)}
        style={{
          width: size,
          height: size,
          margin: 0,
          flex: '0 0 auto',
          accentColor: 'var(--nb-primary)',
          cursor: 'inherit',
        }}
      />
      {label}
    </label>
  );
}
